export const EMPTY_PRODUCT_FORM = {
  name_ar: "",
  name_en: "",
  category_id: "",
  description_ar: "",
  description_en: "",
  is_featured: false,
};
